// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ profile, ...other }) {
  const { user } = useAuth();
  const avatarName = profile ? profile.display_name : user.displayName;
  const photoUrl = profile ? profile.photo_url : user.photoURL;

  return (
    <MAvatar src={photoUrl} alt={avatarName} color={photoUrl ? 'default' : createAvatar(avatarName).color} {...other}>
      {createAvatar(avatarName).name}
    </MAvatar>
  );
}
